import { Language } from 'services/labels';

export type StoreState = {
  language: { languageID: string; language: Language | null; isRTL: boolean };
};
export const selectIsRTL = (state: StoreState) => state.language.isRTL;
